module.exports = __webpack_public_path__ + "static/media/style.8a3ccb92.scss";


//////////////////
// WEBPACK FOOTER
// ./src/component/RatingStats/style.scss
// module id = 1542
// module chunks = 0